import Types from "./Types";

export const setUserAction = (isLoading) => ({
  type: Types.SET_USER_IS_LOADING,
  payload: isLoading,
});

export const getUserDataRequest = () => ({
  type: Types.GET_USER_DATA_REQUEST,
});

export const getUserDataSuccess = (data) => ({
  type: Types.GET_USER_DATA_SUCCESS,
  payload: data,
});

export const getUserDataFail = () => ({
  type: Types.GET_USER_DATA_FAIL,
});

export const getNotificationsRequest = (payload) => ({
  type: Types.GET_NOTIFICATIONS_REQUEST,
  payload,
});

export const getNotificationsSuccess = (data) => ({
  type: Types.GET_NOTIFICATIONS_SUCCESS,
  payload: data,
});

export const getNotificationsFail = () => ({
  type: Types.GET_NOTIFICATIONS_FAIL,
});

export const getGovernoratesRequest = () => ({
  type: Types.GET_GOVERNORATES_REQUEST,
});

export const getGovernoratesSuccess = (data) => ({
  type: Types.GET_GOVERNORATES_SUCCESS,
  payload: data,
});

export const getGovernoratesFail = () => ({
  type: Types.GET_GOVERNORATES_FAIL,
});

export const getMajorsRequest = () => ({
  type: Types.GET_MAJORS_REQUEST,
});

export const getMajorsSuccess = (data) => ({
  type: Types.GET_MAJORS_SUCCESS,
  payload: data,
});

export const getMajorsFail = () => ({
  type: Types.GET_MAJORS_FAIL,
});

export const getGradesRequest = () => ({
  type: Types.GET_GRADES_REQUEST,
});

export const getGradesSuccess = (data) => ({
  type: Types.GET_GRADES_SUCCESS,
  payload: data,
});

export const getGradesFail = () => ({
  type: Types.GET_GRADES_FAIL,
});

export const getUserGroupsRequest = (subject_id) => ({
  type: Types.GET_USER_GROUPS_REQUEST,
  payload: subject_id,
});

export const getUserGroupsSuccess = (data) => ({
  type: Types.GET_USER_GROUPS_SUCCESS,
  payload: data,
});

export const getUserGroupsFail = () => ({
  type: Types.GET_USER_GROUPS_FAIL,
});